export const objMap = <S extends string | number | symbol, T, N = S> (obj: Record<S, T>, mapper: (value: T, key: S) => N) => {
  return Object.fromEntries(
      Object.entries(obj)
        .map(([ key, value ]) => [ key, mapper(value as any, key as S)])
  )
}